import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=656563d9&lang=pug"
import script from "./TheFooter.vue?vue&type=script&lang=ts"
export * from "./TheFooter.vue?vue&type=script&lang=ts"
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=656563d9&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PhoneNumber: require('/app/components/generic/PhoneNumber.vue').default,Icon: require('/app/components/vantone/Icon.vue').default,Trustpilot: require('/app/components/generic/Trustpilot.vue').default})
